import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/runner/work/emissary-webgui/emissary-webgui/layouts/default.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/home/runner/work/emissary-webgui/emissary-webgui/layouts/login.vue").then(m => m.default || m))
}